var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('partica-list2-line',{attrs:{"data":_vm.listcontent(),"buttons":_vm.buttons},on:{"partica-event":_vm.eventHandler}})}
var staticRenderFns = []

export { render, staticRenderFns }